"use client";
import { useState, useEffect } from "react";

/**
 * Detects if the current screen width is below a given breakpoint.
 * Useful for responsive UI logic (e.g., mobile-specific components).
 */
export const useIsMobile = (breakpoint: number = 768) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check window width and update state
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= breakpoint);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, [breakpoint]);

  return isMobile;
};
